export const awsExports = {
    "REGION": import.meta.env.VITE_AWS_REGION,
    "USER_POOL_ID": import.meta.env.VITE_USER_POOL_ID,
    "USER_POOL_APP_CLIENT_ID": import.meta.env.VITE_USER_POOL_APP_CLIENT_ID
};